(function(c, l, a, r, i, t, y) {
  function loadClarity() {
    c[a] = c[a] || function() {
      (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  }

  function scheduleClarity() {
    if ("requestIdleCallback" in c) {
      c.requestIdleCallback(loadClarity, { timeout: 4000 });
    } else {
      c.setTimeout(loadClarity, 1200);
    }
  }

  if (l.readyState === "complete") {
    scheduleClarity();
  } else {
    c.addEventListener("load", scheduleClarity, { once: true });
  }
})(window, document, "clarity", "script", "rdi3rj4md8");



(function () {
  function hasCornerDrawer() {
    return !!document.querySelector(
      '#corner-cowi-cart-summary-card, #corner-cowi-header, #corner-cowi-open-primary-card, #corner-cowi-cart-button-launcher, #corner-cowi-cart-cta-total-price-amount'
    );
  }

  function initSidebarEmail() {
    const targetWrapper = document.querySelector('#corner-cowi-cart-summary-card');
    
    if (!targetWrapper || document.getElementById('custom-cart-email-section')) {
      return false;
    }

    const ctaBtn = document.querySelector('#corner-cowi-cart-summary-card-cta-button');
    if (ctaBtn) ctaBtn.style.display = 'none';

    const container = document.createElement('div');
    container.id = 'custom-cart-email-section';
    container.style.padding = '16px';

    container.innerHTML = `
  <label for="cart-sidebar-email" style="display:block; font-weight: bold; margin-bottom: 8px;">
    Vuoi ricevere un promemoria?
  </label>
  <input type="email" id="cart-sidebar-email" placeholder="Inserisci la tua email" required
    style="width:100%; padding:10px; margin-bottom:10px; border:1px solid #ccc; border-radius:5px;">
  <p id="email-error-msg" style="color:red; display:none; margin-top:10px;">Email non valida</p>
`;

    const reference = document.querySelector('#corner-cowi-cart-secondary-buttons');
    targetWrapper.insertBefore(container, reference);

    const emailInput = document.getElementById('cart-sidebar-email');
    let timer = null;
    emailInput.addEventListener('input', function () {
      const email = emailInput.value.trim();
      const errorMsg = document.getElementById('email-error-msg');
      
      if (validateEmail(email)) {
        errorMsg.style.display = 'none';
        if (timer) clearTimeout(timer);
        
        timer = setTimeout(() => {
          window.location.href = `/checkout?email=${encodeURIComponent(email)}`;
        }, 1500);
      } else {
        if (timer) clearTimeout(timer);
        errorMsg.style.display = 'block';
      }
    });

    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    return true;
  }

  if (!hasCornerDrawer()) return;
  if (initSidebarEmail()) return;

  const observer = new MutationObserver(() => {
    if (initSidebarEmail()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
})();



(function () {
"use strict";

  if (!document.querySelector('#corner-cowi-header, #corner-cowi-cart-cta-total-price-amount, #corner-cowi-open-primary-card')) {
    return;
  }
  
  var TARGET = 69;
  var HEADER_SEL = "#corner-cowi-header";
  var TOTAL_SEL  = "#corner-cowi-cart-cta-total-price-amount span";
  
  function parsePrice(str){return parseFloat(String(str).replace(/[^\d,\.]/g,"").replace(",","."))||0;}
  function cartTotal(){var el=document.querySelector(TOTAL_SEL);return el?parsePrice(el.textContent):0;}
  
  if(!document.getElementById("cornerShippingBannerCSS")){
    var s=document.createElement("style");
    s.id="cornerShippingBannerCSS";
    s.textContent = `
.corner-banner-wrapper {
  position: relative;
  margin: 0 16px 10px;
  border-radius: 8px;
  overflow: hidden;
  min-height: 90px;
}
.corner-cart-banner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 12px;
  font: 700 14px/1.4 system-ui, sans-serif;
  text-align: center;
  color: #1a1a1a;
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.6s;
  pointer-events: none;
}
.corner-cart-banner .track {
  height: 10px;
  background: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 4px;
}
.corner-cart-banner .bar {
  height: 100%;
  width: 0;
  background: #4caf50;
  transition: width 0.4s;
}
.corner-cart-banner .head,
.corner-cart-banner .foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.corner-cart-banner .foot {
  font-size: 11px;
  color: #666;
}`;
    document.head.appendChild(s);
  }
  
  function make(html,bg){var d=document.createElement("div");d.className="corner-cart-banner";d.style.background=bg;d.innerHTML=html;return d;}
  
  // function shipTpl(t){
  // var d=Math.max(0,TARGET-t),p=Math.min(100,Math.max(0,t/TARGET*100)),win=d===0;
  // return{
  // html:'<div class="head"><span>'+(
  //   win?'🎉 Hai diritto alla <strong>spedizione gratuita</strong>!':'🚚 Spedizione gratuita da 69€')+
  //   '</span><span class="badge" style="background:'+(win?'#4caf50':'#ff9800')+
  //   ';color:#fff;padding:3px 8px;border-radius:10px;font-size:12px">'+(
  //   win?'Obiettivo raggiunto':'Mancano <strong>'+d.toFixed(2)+'€</strong>')+
  //   '</span></div><div class="track"><div class="bar" style="width:'+p+'%"></div></div>'+
  //   '<div class="foot"><span>0€</span><span class="current">'+t.toFixed(2)+'€</span><span>'+TARGET+'€</span></div>',
  // bg:win?'linear-gradient(90deg,#e8f5e9,#c8e6c9)':'linear-gradient(90deg,#f0f9f0,#e8f5e9)'
  // };
  // }
  
  function insert(){
    var header=document.querySelector(HEADER_SEL);
    if(!header||document.getElementById("banner-carousel"))return;
    
    var wrap=document.createElement("div");
    wrap.id="banner-carousel";
    wrap.className="corner-banner-wrapper";
    wrap.style.minHeight="90px";
    
    var tiktokBanner=make('💸 Vuoi risparmiare sui costi di spedizione? Acquista tramite il nostro <a href="https://www.tiktok.com/@lightblue_shoponline?_t=ZN-8xnVudQ5Fuo&_r=1" target="_blank" style="color:#fff;text-decoration:underline;font-weight:bold;">🎵 Profilo TikTok</a>!',
      'linear-gradient(90deg,#ff0050,#ff4081,#ff6b9d)'),
      sData=shipTpl(cartTotal()),
      ship=make(sData.html,sData.bg),
      returnBanner=make('🔄 Hai fino a <strong>14 giorni</strong> per effettuare un reso! Acquista con tranquillità.',
        'linear-gradient(90deg,#e7f3ff,#d2e3fc)');
        
        wrap.append(tiktokBanner,ship,returnBanner); header.parentNode.insertBefore(wrap,header.nextSibling);
        
        var list = [tiktokBanner, ship, returnBanner], i = 0;
        
        /*  ▼▼  NUOVE RIGHE  ▼▼  */
        list.forEach(b => b.style.pointerEvents = 'none');  // disabilita tutti
        list[0].style.opacity = 1;                          // rende visibile il primo
        list[0].style.pointerEvents = 'auto';               // e lo rende cliccabile
        /*  ▲▲  NUOVE RIGHE  ▲▲  */
        
        setInterval(function () {
          list[i].style.opacity = 0;
          list[i].style.pointerEvents = 'none';   // banner uscente: non cliccabile
          
          i = (i + 1) % 3;
          
          list[i].style.opacity = 1;
          list[i].style.pointerEvents = 'auto';   // banner entrante: cliccabile
        }, 5000);
        
        function refresh(){
          var tot=cartTotal(),data=shipTpl(tot);
          ship.querySelector(".bar").style.width=data.html.match(/width:(\d+\.?\d*)%/)[1]+"%";
          ship.querySelector(".current").textContent=tot.toFixed(2)+"€";
          ship.querySelector(".head span").innerHTML=data.html.match(/<span>(.*?)<\/span>/)[1];
          var badge=ship.querySelector(".badge");
          badge.innerHTML=data.html.match(/class=\"badge\".*?>(.*?)<\/span>/)[1];
          badge.style.background=data.bg.indexOf("#4caf50")>-1?"#4caf50":"#ff9800";
          ship.style.background=data.bg;
        }
        document.addEventListener("cart:updated",refresh);
        // setInterval(refresh,1500);
      }
      
      // var t=0,chk=setInterval(function(){insert();if(document.getElementById("banner-carousel")||++t>80)clearInterval(chk);},200);
    })();
    
    
    function creaAccessoriMenu(id, hrefCategoria) {
      const mainItem = document.createElement("li");
      mainItem.id = id;
      mainItem.classList.add("t4s-menu-item", "t4s-item-level-0", "t4s-menu-item-has-children", "t4s-only_icon_false");
      
      const mainLink = document.createElement("a");
      mainLink.href = hrefCategoria;
      mainLink.innerHTML = 'Accessori';
      mainItem.appendChild(mainLink);
      
      const subMenu = document.createElement("ul");
      subMenu.classList.add("t4s-sub-menu");
      subMenu.style.display = "none";
      
      const subItems = [
"Anelli",
"Bracciali",
"Collane",
"Orecchini",
"Borse e Pochette",
"Box Regalo / Set"
      ];
      
      subItems.forEach(text => {
        const li = document.createElement("li");
        li.classList.add("t4s-menu-item", "t4s-item-level-1");
        li.style.paddingLeft = "25px";
        
        const a = document.createElement("a");
        a.href = `/search?q=${encodeURIComponent(text)}`;
        a.textContent = text;
        a.style.fontSize = "0.9em";
        a.style.color = "#555";
        a.style.display = "list-item"; // punto elenco
        a.style.listStyleType = "disc"; // visualizza il pallino
        a.style.listStylePosition = "inside";
        
        li.appendChild(a);
        subMenu.appendChild(li);
      });
      
      mainItem.appendChild(subMenu);
      
      // Aggiunge toggle al click
      mainLink.addEventListener("click", function (e) {
        e.preventDefault();
        const isVisible = subMenu.style.display === "block";
        subMenu.style.display = isVisible ? "none" : "block";
      });
      
      return mainItem;
    }
    
    function arricchisciAccessoriStatico() {
      const staticItem = document.getElementById("item_cat_AUb49D");
      if (!staticItem) return;
      
      const mainLink = staticItem.querySelector("a");
      const subMenu = document.createElement("ul");
      subMenu.classList.add("t4s-sub-menu");
      subMenu.style.display = "none";
      
      const subItems = [
"Anelli",
"Bracciali",
"Collane",
"Orecchini",
"Borse e Pochette",
"Box Regalo / Set"
      ];
      
      subItems.forEach(text => {
        const li = document.createElement("li");
        li.classList.add("t4s-menu-item", "t4s-item-level-1");
        li.style.paddingLeft = "25px";
        
        const a = document.createElement("a");
        a.href = `/search?q=${encodeURIComponent(text)}`;
        a.textContent = text;
        a.style.fontSize = "0.9em";
        a.style.color = "#555";
        a.style.display = "list-item";
        a.style.listStyleType = "disc";
        a.style.listStylePosition = "inside";
        
        li.appendChild(a);
        subMenu.appendChild(li);
      });
      
      staticItem.appendChild(subMenu);
      staticItem.classList.add("t4s-menu-item-has-children", "t4s-only_icon_false");
      
      // Rimuove eventuale icona e aggiunge toggle al click
      if (mainLink) {
        mainLink.addEventListener("click", function (e) {
          e.preventDefault();
          const isVisible = subMenu.style.display === "block";
          subMenu.style.display = isVisible ? "none" : "block";
        });
      }
    }
    
    function inserisciAccessoriDopoCerimonie() {
      const cerimonieItem = document.getElementById("item_7c8a9646-d31f-4c64-ba4e-07d7fd4f567c");
      if (!cerimonieItem) return;
      
      const nuovoAccessori = creaAccessoriMenu("item_cat_AUb49D_clone", "/collections/accessori?page=1");
      cerimonieItem.parentNode.insertBefore(nuovoAccessori, cerimonieItem.nextSibling);
    }
    
    const observer = new MutationObserver(() => {
      const accessoriStatico = document.getElementById("item_cat_AUb49D");
      const cerimonie = document.getElementById("item_7c8a9646-d31f-4c64-ba4e-07d7fd4f567c");
      if (accessoriStatico && cerimonie) {
        arricchisciAccessoriStatico();
        inserisciAccessoriDopoCerimonie();
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    
    const products = [
"Abito Sublime", "Maglioncione curvy", "Abito Lumina", "Giacca Lumina", "Abito Velea",
"Dolcevita Basic curvy", "Gonna paillettes curvy", "Maglione con perle", "Light Blue Ring Jewels",
"Cappotto spigato melange", "Pellicciotto lungo", "Gonna satin svasata- Beige", "Gonna satin svasata- Bordeaux",
"Gonna plissè satin - Petrolio", "Gonna plissè satin - Bordeaux", "Camicia con cravatta-Beige", "Camicia con cravatta- Marrone",
"Camicia con cravatta- Nero", "Gonna longuette ecopelle", "Blazer Leo curvy -Verde", "Body velato- Nero",
"Vestito fantasia midi curvy- Magenta", "Vestito fantasia midi curvy- Petrolio", "Tailleur morbido curvy",
"Pantalone work-grigio", "Blazer work - Vinaccia", "Blazer work - Grigio", "Tailleur gessato lurex curvy- Grigio",
"Tailleur gessato lurex curvy- Burro", "Maglia scollo a barchetta - Rosso mattone", "Maglia scollo a barchetta - Nero",
"Maglia basic - Blu navy", "Maglia basic - Nero", "Giacchino corto ecopelle", "Blazer corto con fodera-Nero",
"Blazer corto con fodera-Viola", "Blazer corto con fodera-Petrolio", "Blazer corto con fodera- Rosa cipria",
"Vestito animalier- maculato", "Vestito animalier- leopardato", "Gonna lunga bottoni", "Vestito Sangallo",
"Pantalone Fantasy"
    ];
    
    // Lista delle chiavi di ricerca
    const searchTags = [
"abito elegante", "vestito lungo", "vestito corto", "abito cerimonia", "vestito cerimonia", "tubino elegante",
"abito sera", "vestito paillettes", "vestito gala", "vestito monospalla", "look chic", "abito midi", "vestito casual",
"chemisier donna", "camicetta lino", "camicia satin", "vestito floreale", "gonna plissé", "coordinato donna",
"pantalone palazzo", "blazer corto", "abito estivo", "vestito leggero", "look estate", "abito boho", "abito mare",
"vestito Mykonos", "vestito Santorini", "gonna lunga", "crop top", "jumpsuit donna", "vestito animalier",
"giacca ecopelle", "chiodo borchie", "pantaloni cargo", "blazer maculato", "gonna ecopelle", "shorts vita alta",
"pantaloni zampa", "outfit party", "abito party", "vestito capodanno", "abito lurex", "tubino strass",
"minigonna paillettes", "blazer tweed", "cappotto lungo", "trench pelle", "ecopelliccia nera", "look autunno",
"vestito velluto", "dolcevita donna", "tailleur elegante", "blazer pantalone", "coordinato gonna", "outfit business",
"look total white", "cinturina strass", "orecchini brillanti", "pochette rafia", "collana medaglione", "set gioielli",
"stola raso", "cintura fashion", "borsa cerimonia"
    ];
    
    document.addEventListener("DOMContentLoaded", function () {
      function initSearchPlaceholder() {
        const inputField = document.querySelector(".t4s-mini-search__input");
        if (!inputField) {
          setTimeout(initSearchPlaceholder, 500);
          return;
        }
        
        const inputContainer = inputField.parentElement;
        // let charIndex = 0;
        // let deleting = false;
        // let productIndex = Math.floor(Math.random() * products.length);
        // let typingActive = true;
        
        // const placeholderSpan = document.createElement("span");
        // placeholderSpan.style.position = "absolute";
        // placeholderSpan.style.left = "10px";
        // placeholderSpan.style.top = "50%";
        // placeholderSpan.style.fontSize = "0.85em"; // Riduce leggermente il font
        
        // placeholderSpan.style.transform = "translateY(-50%)";
        // placeholderSpan.style.pointerEvents = "none";
        // placeholderSpan.style.fontSize = "0.65em"; // Riduce leggermente il font
        // placeholderSpan.style.fontFamily = window.getComputedStyle(inputField).fontFamily;
        // placeholderSpan.style.color = "rgba(0, 0, 0, 0.5)";
        // placeholderSpan.style.whiteSpace = "nowrap";
        // placeholderSpan.style.overflow = "hidden";
        // placeholderSpan.style.maxWidth = "100%";
        // placeholderSpan.style.transition = "opacity 0.3s ease";
        // inputField.style.position = "relative";
        
        // inputField.setAttribute("placeholder", "");
        // inputContainer.appendChild(placeholderSpan);
        
        // function getColorGradient(index, length) {
        //   const hue = 220 + (index / length) * 40;
        //   return `hsl(${hue}, 100%, 70%)`;
        // }
        
        // function applyGlowEffect(text) {
        //   return text.split('').map((char, i) => 
          //   `<span style="color: ${getColorGradient(i, text.length)}; font-weight: bold; text-shadow: 0 0 8px rgba(0, 132, 255, 0.8), 0 0 12px rgba(0, 162, 255, 0.6);">${char}</span>`
        //   ).join('');
        // }
        
        // function typeEffect() {
        //   if (!typingActive) return;
        //   let baseText = "Cerca ";
        //   let productText = `"${products[productIndex]}"`;
        
        //   if (!deleting) {
        //     placeholderSpan.innerHTML = baseText + applyGlowEffect(productText.substring(0, charIndex));
        //     charIndex++;
        //     if (charIndex > productText.length) {
        //       setTimeout(() => deleting = true, 1000);
        //     }
        //   } else {
        //     placeholderSpan.innerHTML = baseText + applyGlowEffect(productText.substring(0, charIndex));
        //     charIndex--;
        //     if (charIndex === 0) {
        //       deleting = false;
        //       productIndex = Math.floor(Math.random() * products.length);
        //     }
        //   }
        //   setTimeout(typeEffect, deleting ? 50 : 100);
        // }
        inputField.setAttribute("placeholder", "Cerca nel nostro catalogo...");
        
        // typeEffect();
        
        // Creazione suggerimenti
        const suggestionContainer = document.createElement("div");
        suggestionContainer.style.marginTop = "10px";
        suggestionContainer.style.display = "flex";
        suggestionContainer.style.flexWrap = "wrap";
        suggestionContainer.style.gap = "2px";
        suggestionContainer.style.alignItems = "center";
        
        const suggestionLabel = document.createElement("span");
        suggestionLabel.textContent = "Suggerimenti:";
        suggestionLabel.style.fontWeight = "bold";
        suggestionLabel.style.color = "#333";
        suggestionContainer.appendChild(suggestionLabel);
        inputContainer.parentElement.appendChild(suggestionContainer);
        
        function createTag(tagText) {
          const tag = document.createElement("span");
          tag.textContent = tagText;
          tag.style.padding = "4px 10px";
          tag.style.borderRadius = "5px";
          tag.style.backgroundColor = "#2393ce";
          tag.style.color = "#fff";
          tag.style.cursor = "pointer";
          tag.style.fontSize = "10px";
          tag.style.fontWeight = "bold";
          
          tag.addEventListener("click", () => {
            inputField.value = tagText;
            inputField.dispatchEvent(new Event("input", { bubbles: true }));
            inputField.dispatchEvent(new Event("change", { bubbles: true }));
            inputField.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true, key: "Enter", code: "Enter" }));
            inputField.focus();
            inputField.dispatchEvent(new Event("input", { bubbles: true }));
            inputField.focus();
          });
          
          return tag;
        }
        
        // Genera 12 chiavi di ricerca casuali
        let selectedTags = [];
        while (selectedTags.length < 12) {
          let randomTag = searchTags[Math.floor(Math.random() * searchTags.length)];
          if (!selectedTags.includes(randomTag)) {
            selectedTags.push(randomTag);
          }
        }
        
        selectedTags.forEach(tag => suggestionContainer.appendChild(createTag(tag)));
        
        // inputField.addEventListener("input", () => {
          //   if (inputField.value.length > 0) {
        //     typingActive = false;
        //     placeholderSpan.style.opacity = "0";
        //   } else {
        //     typingActive = true;
        //     placeholderSpan.style.opacity = "1";
        //     setTimeout(typeEffect, 500);
        //   }
        // });
        
      }
      
      
      setTimeout(initSearchPlaceholder, 1000);
      
      
      //Carosello banner homepage
      const carousel = document.querySelector('.carousel');
      
      if (carousel) {
        const items = [...carousel.children];
        const prevBtn = document.querySelector('.prev');
        const nextBtn = document.querySelector('.next');
        let index = 0;
        
        function updateCarousel() {
          const itemWidth = items[0].getBoundingClientRect().width + 20;
          carousel.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
        }
        
        prevBtn.addEventListener('click', () => {
          index = index > 0 ? index - 1 : items.length - 1;
          updateCarousel();
        });
        
        nextBtn.addEventListener('click', () => {
          index = index < items.length - 1 ? index + 1 : 0;
          updateCarousel();
        });
        
        // Drag to scroll
        let isDown = false;
        let startX;
        let scrollLeft;
        
        carousel.addEventListener('mousedown', (e) => {
          isDown = true;
          startX = e.pageX - carousel.offsetLeft;
          scrollLeft = carousel.scrollLeft;
        });
        
        carousel.addEventListener('mouseleave', () => {
          isDown = false;
        });
        
        carousel.addEventListener('mouseup', () => {
          isDown = false;
        });
        
        carousel.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - carousel.offsetLeft;
          const walk = (x - startX) * 2;
          carousel.scrollLeft = scrollLeft - walk;
        });
      }
      
      //Carosello banner homepage
      
      
      
      
      
      
      // setInterval(checkCart, 3000);
      // let searchIcon = document.querySelector(".t4s-site-nav__search a"); // Seleziona l'icona della lente
      
      // Prendi l'URL corrente
      var urlParams = new URLSearchParams(window.location.search);
      
      // Controlla se è presente la variabile "action" con valore "subscribe"
      if (urlParams.get('action') === 'subscribe') {
        // Esegui lo scroll dopo un piccolo ritardo (opzionale, utile per far caricare tutto)
        setTimeout(function() {
          var banner = document.getElementById("shopify-section-template--19810069643561__banner_parallax_RVLXAw");
          
          if (banner) {
            banner.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 500); // 500 ms per sicurezza, puoi aumentare se serve
      }
      const slides = document.querySelectorAll('#Slider-template--21889776058650__7f605315-d394-435b-92ba-1b40e362f48e > .swiper-slide');
      slides.forEach(slide => {
        if (slide.getAttribute('role') === 'group') {
          slide.setAttribute('role', 'listitem');
        }
      });
      
      const searchDrawer = document.getElementById("t4s-search-hidden");
      if (searchDrawer) {
        const observerDrawerOpen = new MutationObserver(() => {
          if (searchDrawer.classList.contains("active")) {
            const input = searchDrawer.querySelector('.t4s-mini-search__input');
            if (input) setTimeout(() => input.focus(), 100);
          }
        });
        observerDrawerOpen.observe(searchDrawer, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    });
    let searchIcon = document.querySelector(".t4s-site-nav__search a");
    let searchBox = document.getElementById("t4s-search-hidden");
    let overlay = document.querySelector(".t4s-close-overlay"); // Usa l'overlay esistente
    
    // Funzione per aprire la barra di ricerca
    function openSearch() {
      if (!searchBox || !overlay) return;
      searchBox.classList.add("active");
      overlay.classList.add("active");
    }
    
    // Funzione per chiudere la barra di ricerca
    function closeSearch() {
      if (!searchBox || !overlay) return;
      searchBox.classList.remove("active");
      overlay.classList.remove("active");
    }
    
    // Apre la barra al click sulla lente
    if (searchIcon && searchBox && overlay) {
      searchIcon.addEventListener("click", function (event) {
        event.preventDefault();
        openSearch();
      });
      
      // Chiude la barra cliccando sull'overlay
      overlay.addEventListener("click", closeSearch);
    }
    
    // Chiude la barra premendo il tasto ESC
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeSearch();
      }
    });
    
    const popup = document.getElementById('support-popup');
    if (popup) {
      popup.classList.add('show');
      setTimeout(() => {
        popup.classList.remove('show');
      }, 5000);
    }
    
    
    
    window.renderBadge = function() {
      return 0;
      var ratingBadgeContainer = document.createElement("div");
      document.body.appendChild(ratingBadgeContainer);
      window.gapi.load('ratingbadge', function() {
        window.gapi.ratingbadge.render(ratingBadgeContainer, {"merchant_id": 5388139411});
      });
    }
    
    
    if ('serviceWorker' in navigator && location.origin === 'https://lightblueshop.com') {
      navigator.serviceWorker.register('/cdn/shop/t/3/assets/service-worker.js?v=1')
        .then(reg => console.log('✅ Service Worker registrato:', reg))
        .catch(err => console.error('❌ Errore registrazione Service Worker:', err));
    }
    
    
    var script = document.createElement('script');
    script.src = "https://lightblueshop.com/cdn/shop/t/3/assets/pwa-notifications.js?v=1";
    script.onload = () => console.log('✅ pwa-notifications.js caricato!');
    script.onerror = () => console.error('❌ Errore caricamento pwa-notifications.js');
    document.body.appendChild(script);
    
    
    
    // Seleziona il link dell'account basandoti sulla classe corretta
    const accountIcon = document.querySelector(".t4s-site-nav__icon.t4s-site-nav__account a");
    
    if (accountIcon) {
      accountIcon.addEventListener("click", function (event) {
        event.preventDefault(); // Previeni la navigazione alla pagina di login
        window.location.href = "https://shopify.com/77747192105/account";
      });
    }
    
    
